import BankAccountFundAutomaticBackupResponseModel from '@/models/bankaccounts/BankAccountFundAutomaticBackupResponseModel';

export default class BankAccountAutomaticBackupResponseModel {
    public hasBackup = false;
    public debits: number = 0;
    public credits: number = 0;
    public balance: number = 0;
    public bankAccountName = '';
    public availableFunds: number = 0;
    public availableTransactions: number = 0;
    public backupDateTimeUtc?: Date;

    public funds: BankAccountFundAutomaticBackupResponseModel[] = [];
}
